
import { ThemeSwitcher } from '@/components/shared/ThemeSwitcher';
import LanguageSwitcher from '@/components/shared/LanguageSwitcher';
import iconoMacroindustrial from '@/assets/Icono-macroindustrial.png';
import { useAuthStore } from '@/stores/auth.store';
import { useTranslation } from 'react-i18next';

interface OpenMenuProps {
  handleOpenModal: () => void;
  handleOpenSignupModal: ()=> void;
}

export function OpenMenu({ handleOpenModal, handleOpenSignupModal }: OpenMenuProps) {
  const { isLoggedIn } = useAuthStore();
  const { t } = useTranslation('translation');

  return (
    <nav className="top-0 w-full bg-white/90 dark:bg-gray-900/90 backdrop-blur-md border-b border-gray-200 dark:border-gray-700 shadow-sm z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center h-20">
          <div className="flex items-center gap-3">
            <img
              src={iconoMacroindustrial}
              alt="Macroindustrial"
              className="w-12 h-12 object-contain"
            />
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Macroindustrial ERP Pro</h1>
          </div>
          <div className="hidden md:flex items-center gap-8 ml-auto">
            {!isLoggedIn && (
              <>
                <a href="#features" className="text-gray-600 hover:text-orange-600 dark:text-gray-300 dark:hover:text-orange-400 transition-colors">
                  {t('landing.features.navtitle', 'Características')}
                </a>
                <a href="#benefits" className="text-gray-600 hover:text-orange-600 dark:text-gray-300 dark:hover:text-orange-400 transition-colors">
                  {t('landing.benefits.title', 'Beneficios')}
                </a>
                <a href="#pricing" className="text-gray-600 hover:text-orange-600 dark:text-gray-300 dark:hover:text-orange-400 transition-colors">
                  {t('landing.pricing.navtitle', 'Precios')}
                </a>
                <button
                  onClick={handleOpenModal}
                  className="text-gray-600 hover:text-orange-600 dark:text-gray-300 dark:hover:text-orange-400 transition-colors font-medium"
                >
                  {t('landing.hero.ctaButton', 'Ingresar')}
                </button>
                <button
                  onClick={handleOpenSignupModal}
                  className="px-6 py-2.5 bg-orange-500 text-white font-semibold rounded-full hover:bg-orange-600 transition-all shadow-md"
                >
                  {t('landing.pricing.trialButton', 'Comienza gratis')}
                </button>
              </>
            )}
            <LanguageSwitcher />
            <ThemeSwitcher />
          </div>
        </div>
      </div>
    </nav>
  );
}
